import React, { useState, useRef } from 'react';

function DebouncedSearch({ placeholder, query, update }) {
  const [value, setValue] = useState(query || "");
  const timeoutRef = useRef(null);

  function debouncedSearch(string) {
    if(timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      update(string)
    }, 300)
  }

  return (
    <input
      id="search-input"
      placeholder={placeholder}
      className="w-[160px] h-[40px] block shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
      type="search"
      value={value}
      onChange={(e) => {
        e.preventDefault();
        setValue(e.target.value);
        debouncedSearch(e.target.value);
      }}
      name="q"
    />
  )

}
export default DebouncedSearch;